import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import styles from './OrderSummarySteppedSkeleton.module.scss';

const OrderSummarySteppedWrapper = () => (
  <div
    data-testid="component-no-review-step"
    className={styles['cart-summary-container']}
  >
    <Stack spacing={1}>
      <Skeleton variant="text" sx={{ fontSize: '1rem' }} />

      <div className={styles['cart-summary-skeleton-top-section-container']}>
        <div className={styles['cart-summary-skeleton-top-section-item']}>
          <div
            className={styles['cart-summary-skeleton-top-section-item-title']}
          >
            <Skeleton variant="text" width="30%" sx={{ fontSize: '1rem' }} />
            <Skeleton variant="text" width="10%" sx={{ fontSize: '1rem' }} />
          </div>

          <div
            className={styles['cart-summary-skeleton-top-section-item-content']}
          >
            <Skeleton variant="text" width="10%" sx={{ fontSize: '1rem' }} />
            <Skeleton variant="text" width="10%" sx={{ fontSize: '1rem' }} />
          </div>
        </div>
        <div className={styles['cart-summary-skeleton-top-section-item']}>
          <div
            className={styles['cart-summary-skeleton-top-section-item-title']}
          >
            <Skeleton variant="text" width="30%" sx={{ fontSize: '1rem' }} />
            <Skeleton variant="text" width="10%" sx={{ fontSize: '1rem' }} />
          </div>

          <div
            className={styles['cart-summary-skeleton-top-section-item-content']}
          >
            <Skeleton variant="text" width="10%" sx={{ fontSize: '1rem' }} />
            <Skeleton variant="text" width="10%" sx={{ fontSize: '1rem' }} />
          </div>
        </div>
      </div>

      <Skeleton variant="circular" width={40} height={40} />
      <Skeleton variant="rectangular" width={210} height={60} />
      <Skeleton variant="rounded" width={210} height={60} />
    </Stack>
  </div>
);

export default OrderSummarySteppedWrapper;
